import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SCREEN } from 'scenes/common/types/screen';

import { Button } from './chroma';
import SubmitButton from './SubmitButton';

interface SaveEmailSubmitButtonGroupProps {
  submitEnabled: boolean;
  onClickSaveQuoteModal?: Function;
}

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  & > div {
    width: 100%;
  }
  & > :first-child {
    padding-right: 4px;
  }

  & > :last-child {
    padding-left: 4px;
  }

  @media (max-width: ${SCREEN.LARGE}px) {
    margin-bottom: 1.5rem;
  }
`;

export const SaveEmailSubmitButtonGroup: FunctionComponent<SaveEmailSubmitButtonGroupProps> = ({
  onClickSaveQuoteModal,
  submitEnabled,
}) => (
  <ButtonWrapper>
    {onClickSaveQuoteModal && (
      <Button secondary maxWidth onClick={onClickSaveQuoteModal}>
        Save &amp; Email
      </Button>
    )}
    <SubmitButton enabled={submitEnabled}>Next</SubmitButton>
  </ButtonWrapper>
);

export default SaveEmailSubmitButtonGroup;
